module.exports = __webpack_public_path__ + "img/rule-title.b17bd8ad.png";